module.exports = __webpack_public_path__ + "static/media/55_000038.9a1b0eec.jpg";